// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607280333/js/" + chunkId + "." + {"44":"4ac94246","225":"8c08231f","481":"20e05756","486":"2e9f6a35","770":"7e668749"}[chunkId] + ".0.8637150960909552.chunk.js";
};